import { useMutation } from "@tanstack/react-query";
import { savePostChapterAssessment } from "./utils.api";

export const useSavePostChapterAssessment = () =>
    useMutation({
        mutationFn: (body) =>
            savePostChapterAssessment(body),
    });